import { observable, computed, action } from "mobx"; // set, toJS
import { Hand } from "./Hand";
import { store } from "../mainStore";

export class Match {
	@observable matchId = null;
	@observable round = 0;
	@observable type = '1v1';
	@observable goals = [];

	@observable handNumber = 1;
	@observable hands = [];

	@observable currentHand = null;
	@observable status = 0;
	@observable state = '';

	@observable complete = false;

	@observable roundCount = 3;

	@observable fromResume = false;
	@observable canApplyFreeroll = false;
	@observable canApplyHandReset = false;

	@computed get goal(){
		return this.goals[this.goals.length - 1];
	}

	@observable rounds = [];

	constructor(matchData, mode, network) {
		if(network){
			this.matchId = matchData.Id;
			this.status = matchData.UserCurrentRound;
			this.round = matchData.UserCurrentRound;
			this.handNumber = matchData.UserCurrentRound;

			this.canAcceptChallenge = matchData.CanAcceptChallenge;
			this.isStartHand = matchData.IsStartHand;
			this.canRollDice = matchData.CanRollDice;
			this.canApplyFreeroll = matchData.CanApplyFreeroll;
			this.freeRollCost = matchData.FreeRollCost;
			this.userFreeRolls = matchData.UserFreeRolls;
			this.userFreeRollsUsed = matchData.UserFreeRollsUsed;
			this.canApplyHandReset = matchData.CanApplyHandReset;
			this.canKeepHand = matchData.CanKeepHand;
			this.canResignMatch = matchData.CanResignMatch;
			this.canClaimReward = matchData.CanClaimReward;

			this.playerCount = matchData.PlayerCount;
			this.creatorId = matchData.CreatorId;

			store.currentStake = matchData.Bid && matchData.Bid > 0 ? matchData.Bid : 50;
			store.currentPot = matchData.Pot ? matchData.Pot : 0;

			this.rounds = matchData.Rounds;
			this.roundCount = matchData.RoundCount;

			this.goals.replace(matchData.Rounds.map(r => window.manager.hands[r.TargetHand]));
			var heartsUsed = 0;
			matchData.UserMatchRounds.forEach((round) => {
				this.hands.push(new Hand(round, true));
				if(round.Rolls.length > 3){
					heartsUsed += round.Rolls.length - 3;
				}
			})
			this.hearts = matchData.UserFreeRolls - heartsUsed;
			this.currentHand = this.hands[this.hands.length - 1];
			this.state = matchData.State;
			this.userState = matchData.UserState;
			this.needToAcceptChallenge = matchData.UserState === 'pe';
			this.type = matchData.Type;
		} else {
			Object.assign(this, matchData);
		}
	}

	@action start(){}
}
